const create_broadcast_list_show = (state = [], action) => {
  switch (action.type) {
    case "create_broadcast_list_store":
      return action.payload;
    default:
      return state;
  }
};

export default create_broadcast_list_show;
